import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Business
 * @static
 * @hideconstructor
*/

/**
 * Get all the main business
 * @method getJobById
 * @name Jobin.Business.getMainBusinesses
 * @param {Array} levelArray
 * @param {string} id
 * @returns {Array} Business ParseObjects.
 */
export function getMainBusinesses(_x, _x2) {
  return _getMainBusinesses.apply(this, arguments);
}

/**
 * Get all the job info
 * @method setBusinessForJob
 * @name Jobin.Business.setBusinessForJob
 * @returns {boolean} Success.
 */
function _getMainBusinesses() {
  _getMainBusinesses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(levelArray, id) {
    var Business, query, allResults, skip, limit, results;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          Business = Parse.Object.extend("Business");
          query = new Parse.Query(Business);
          query.equalTo("Main", true);
          if (levelArray && levelArray.length > 0) query.containedIn("Level", levelArray);
          if (id && id.length > 0) query.startsWith("Name", id);
          query.descending("createdAt");
          allResults = [];
          skip = 0;
          limit = 100;
          _context.prev = 9;
        case 10:
          if (!true) {
            _context.next = 22;
            break;
          }
          query.limit(limit);
          query.skip(skip);
          _context.next = 15;
          return query.find();
        case 15:
          results = _context.sent;
          allResults.push.apply(allResults, _toConsumableArray(results));
          skip += limit;
          if (!(results.length === 0 || results.length < limit)) {
            _context.next = 20;
            break;
          }
          return _context.abrupt("break", 22);
        case 20:
          _context.next = 10;
          break;
        case 22:
          return _context.abrupt("return", {
            status: 'ok',
            result: allResults
          });
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](9);
          console.error(_context.t0);
          return _context.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido obtener los negocios principales."
          });
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9, 25]]);
  }));
  return _getMainBusinesses.apply(this, arguments);
}
export function setBusinessForJob(_x3, _x4) {
  return _setBusinessForJob.apply(this, arguments);
}
/**
 * Get all the main business
 * @method getJobById
 * @name Jobin.Business.getMainBusinesses
 * @returns {Array} Business ParseObjects.
 */
function _setBusinessForJob() {
  _setBusinessForJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(business, job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Parse.Cloud.run("changeJobBusiness", {
            jobId: job.id,
            businessId: business.id,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context2.sent;
          if (!result) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", {
            status: 'ok',
            result: true
          });
        case 8:
          return _context2.abrupt("return", {
            status: 'error',
            result: 'Algo ha fallado al tratar de cambiar el negocio de este trabajo.'
          });
        case 9:
          _context2.next = 15;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
          return _context2.abrupt("return", {
            status: 'error',
            result: 'Algo ha fallado al tratar de cambiar el negocio de este trabajo.'
          });
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  }));
  return _setBusinessForJob.apply(this, arguments);
}
export function getById(_x5) {
  return _getById.apply(this, arguments);
}
/**
 * Get Business billing info
 * @method getBillingInfo
 * @name Jobin.Business.getBillingInfo
 * @param {ParseObject} business Business ParseObject
 * @returns {ParseObject} BillingInfo ParseObjects.
 */
function _getById() {
  _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(businessId) {
    var Business, query, result;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          Business = Parse.Object.extend("Business");
          query = new Parse.Query(Business);
          query.equalTo("objectId", businessId);
          _context3.prev = 3;
          _context3.next = 6;
          return query.first();
        case 6:
          result = _context3.sent;
          if (!result) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return", {
            status: 'ok',
            result: result
          });
        case 11:
          return _context3.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido obtener el negocio."
          });
        case 12:
          _context3.next = 18;
          break;
        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](3);
          console.error(_context3.t0);
          return _context3.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido obtener el negocio."
          });
        case 18:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 14]]);
  }));
  return _getById.apply(this, arguments);
}
export function getBillingInfo(_x6) {
  return _getBillingInfo.apply(this, arguments);
}
/**
 * Get the business by name
 * @method getByName
 * @name Jobin.Business.getByName
 * @returns {Object} Business ParseObject.
 */
function _getBillingInfo() {
  _getBillingInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(business) {
    var BillingInfo, query;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          BillingInfo = Parse.Object.extend("BillingInfo");
          query = new Parse.Query(BillingInfo);
          query.equalTo("Business", business);
          _context4.prev = 3;
          _context4.next = 6;
          return query.first();
        case 6:
          _context4.t0 = _context4.sent;
          return _context4.abrupt("return", {
            status: 'ok',
            result: _context4.t0
          });
        case 10:
          _context4.prev = 10;
          _context4.t1 = _context4["catch"](3);
          console.error(_context4.t1);
          return _context4.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido obtener la información de facturación."
          });
        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 10]]);
  }));
  return _getBillingInfo.apply(this, arguments);
}
export function getByName(_x7) {
  return _getByName.apply(this, arguments);
}
/**
 * gets payments related to the provided business identifier
 * @method getPayments
 * @name Jobin.Payment.getPayments
 * @param {ParseObject} business
 * @param {string} monthYear
 * @returns {ParseObject} Payments
 */
function _getByName() {
  _getByName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(businessName) {
    var Business, query, result;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          Business = Parse.Object.extend("Business");
          query = new Parse.Query(Business);
          query.equalTo("Name", businessName);
          _context5.prev = 3;
          _context5.next = 6;
          return query.first();
        case 6:
          result = _context5.sent;
          if (!result) {
            _context5.next = 11;
            break;
          }
          return _context5.abrupt("return", {
            status: 'ok',
            result: result
          });
        case 11:
          return _context5.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido obtener el negocio."
          });
        case 12:
          _context5.next = 18;
          break;
        case 14:
          _context5.prev = 14;
          _context5.t0 = _context5["catch"](3);
          console.error(_context5.t0);
          return _context5.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido obtener el negocio."
          });
        case 18:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[3, 14]]);
  }));
  return _getByName.apply(this, arguments);
}
export function getPayments(_x8, _x9) {
  return _getPayments.apply(this, arguments);
}
/**
 * gets payoffs payments related to the provided business identifier
 * @method getPayoffs
 * @name Jobin.Payment.getPayoffs
 * @param {ParseObject} business
 * @param {string} monthYear
 * @returns {Array} Parse Object Payments
 */
function _getPayments() {
  _getPayments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(business, monthYear) {
    var currentUser, date, startDate, endDate, cloudPromise, paymentsArray, query;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context6.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context6.next = 31;
            break;
          }
          if (!monthYear) {
            _context6.next = 28;
            break;
          }
          date = new Date(monthYear.split("-")[1], monthYear.split("-")[0] - 1, 1);
          startDate = new Date(date.getFullYear(), date.getMonth(), 1);
          endDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          cloudPromise = Parse.Cloud.run("getBusinessFinishPayments", {
            businessId: business.id,
            finishDateFrom: startDate,
            finishDateTo: endDate
          });
          _context6.prev = 9;
          _context6.next = 12;
          return cloudPromise;
        case 12:
          paymentsArray = _context6.sent;
          query = new Parse.Query("Payments");
          query.containedIn("objectId", paymentsArray);
          query.ascending("createdAt");
          _context6.next = 18;
          return query.find();
        case 18:
          _context6.t0 = _context6.sent;
          return _context6.abrupt("return", {
            status: "ok",
            result: _context6.t0
          });
        case 22:
          _context6.prev = 22;
          _context6.t1 = _context6["catch"](9);
          console.error(_context6.t1);
          return _context6.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no hemos podido obtener los pagos pendientes de este mes."
          });
        case 26:
          _context6.next = 29;
          break;
        case 28:
          return _context6.abrupt("return", {
            status: "error",
            result: "Debes seleccionar un rango de fecha."
          });
        case 29:
          _context6.next = 32;
          break;
        case 31:
          return _context6.abrupt("return", {
            status: "error",
            result: "No tienes permisos para hacer esta petición."
          });
        case 32:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[9, 22]]);
  }));
  return _getPayments.apply(this, arguments);
}
export function getPayoffs(_x10, _x11) {
  return _getPayoffs.apply(this, arguments);
}
/**
 * @method createBillingInfo
 * @name Jobin.Business.createBillingInfo
 * @param {Parse.Object} business 
 * @param {string} fiscalName - Name used in fiscal issues
 * @param {string} identityNumber - User's identity number
 * @param {string} fiscalAddress  - Address used in fiscal issues
 * @param {string} fiscalPostalCode  - Postal code of the fiscal address
 * @param {string} fiscalCity  - City of the fiscal address
 * @returns {Parse.Object} - BillingInfo object
 * @deprecated This method is not yet supported by the Jobin Cloud
 */
function _getPayoffs() {
  _getPayoffs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(business, monthYear) {
    var currentUser, date, startDate, endDate, query;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context7.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context7.next = 28;
            break;
          }
          if (!monthYear) {
            _context7.next = 25;
            break;
          }
          date = new Date(monthYear.split("-")[1], monthYear.split("-")[0] - 1, 1);
          startDate = new Date(date.getFullYear(), date.getMonth(), 1);
          endDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          query = new Parse.Query("Payments");
          query.greaterThan("createdAt", startDate);
          query.lessThan("createdAt", endDate);
          query.equalTo("Business", business);
          query.equalTo("Type", "payoff");
          _context7.prev = 13;
          _context7.next = 16;
          return query.find();
        case 16:
          _context7.t0 = _context7.sent;
          return _context7.abrupt("return", {
            status: 'ok',
            result: _context7.t0
          });
        case 20:
          _context7.prev = 20;
          _context7.t1 = _context7["catch"](13);
          return _context7.abrupt("return", {
            status: 'error',
            result: 'Fallo al buscar facturas emitidas a este negocio'
          });
        case 23:
          _context7.next = 26;
          break;
        case 25:
          return _context7.abrupt("return", {
            status: "error",
            result: "Debes seleccionar un rango de fecha."
          });
        case 26:
          _context7.next = 29;
          break;
        case 28:
          return _context7.abrupt("return", {
            status: "error",
            result: "No tienes permisos para hacer esta petición."
          });
        case 29:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[13, 20]]);
  }));
  return _getPayoffs.apply(this, arguments);
}
export function createBillingInfo(_x12, _x13, _x14, _x15, _x16, _x17) {
  return _createBillingInfo.apply(this, arguments);
}
/**
 * Set the contact of a business
 * @method setContact
 * @name Jobin.Business.setContact
 * @param {ParseObject} business Business ParseObject
 * @param {string} name
 * @param {string} phone
 * @returns {ParseObject} Business object updated
 */
function _createBillingInfo() {
  _createBillingInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(business, fiscalName, identityNumber, fiscalAddress, fiscalPostalCode, fiscalCity) {
    var cloudPromise;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          cloudPromise = Parse.Cloud.run("createBillingInfo", {
            fiscalName: fiscalName,
            identityNumber: identityNumber,
            fiscalAddress: fiscalAddress,
            fiscalPostalCode: fiscalPostalCode,
            fiscalCity: fiscalCity,
            businessId: business.id
          });
          _context8.prev = 1;
          _context8.next = 4;
          return cloudPromise;
        case 4:
          _context8.t0 = _context8.sent;
          return _context8.abrupt("return", {
            status: "ok",
            result: _context8.t0
          });
        case 8:
          _context8.prev = 8;
          _context8.t1 = _context8["catch"](1);
          console.error(_context8.t1);
          return _context8.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no hemos podido crear la información de facturación."
          });
        case 12:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[1, 8]]);
  }));
  return _createBillingInfo.apply(this, arguments);
}
export function setContact(_x18, _x19, _x20, _x21) {
  return _setContact.apply(this, arguments);
}
/**
 * Set the billing preference of a business
 * @method setBillingPreference
 * @name Jobin.Business.setBillingPreference
 * @param {ParseObject} business Business ParseObject
 * @param {string} preference
 * @returns {ParseObject} Business object updated
 */
function _setContact() {
  _setContact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(business, name, phone, email) {
    var result;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          business.set("ContactName", name);
          business.set("ContactPhone", phone);
          business.set("ContactEmail", email);
          _context9.prev = 3;
          _context9.next = 6;
          return business.save();
        case 6:
          result = _context9.sent;
          if (!result) {
            _context9.next = 11;
            break;
          }
          return _context9.abrupt("return", {
            status: 'ok',
            result: business
          });
        case 11:
          return _context9.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido actualizar la información de contacto del negocio."
          });
        case 12:
          _context9.next = 18;
          break;
        case 14:
          _context9.prev = 14;
          _context9.t0 = _context9["catch"](3);
          console.error(_context9.t0);
          return _context9.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido actualizar la información de contacto del negocio."
          });
        case 18:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[3, 14]]);
  }));
  return _setContact.apply(this, arguments);
}
export function setBillingPreference(_x22, _x23) {
  return _setBillingPreference.apply(this, arguments);
}
/**
 * Set the contact of a business
 * @method setBillingInfo
 * @name Jobin.Business.setBillingInfo
 * @param {ParseObject} business Business ParseObject
 * @param {string} fiscalName
 * @param {string} identityNumber
 * @param {string} address
 * @param {string} postalCode
 * @param {string} city
 * @returns {ParseObject} Business object updated
 */
function _setBillingPreference() {
  _setBillingPreference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(business, preference) {
    var result;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          business.set("BillingPreference", preference);
          _context10.prev = 1;
          _context10.next = 4;
          return business.save();
        case 4:
          result = _context10.sent;
          if (!result) {
            _context10.next = 9;
            break;
          }
          return _context10.abrupt("return", {
            status: 'ok',
            result: business
          });
        case 9:
          return _context10.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido actualizar la preferencia de facturación del negocio."
          });
        case 10:
          _context10.next = 16;
          break;
        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](1);
          console.error(_context10.t0);
          return _context10.abrupt("return", {
            status: 'error',
            result: "Algo ha fallado y no hemos podido actualizar la preferencia de facturación del negocio."
          });
        case 16:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[1, 12]]);
  }));
  return _setBillingPreference.apply(this, arguments);
}
export function setBillingInfo(_x24, _x25, _x26, _x27, _x28, _x29) {
  return _setBillingInfo.apply(this, arguments);
}
function _setBillingInfo() {
  _setBillingInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(business, fiscalName, identityNumber, address, postalCode, city) {
    var cloudPromise;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          cloudPromise = Parse.Cloud.run("createBillingInfo", {
            fiscalName: fiscalName,
            identityNumber: identityNumber,
            fiscalAddress: address,
            fiscalPostalCode: postalCode,
            fiscalCity: city,
            businessId: business.id
          });
          _context11.prev = 1;
          _context11.next = 4;
          return cloudPromise;
        case 4:
          _context11.t0 = _context11.sent;
          return _context11.abrupt("return", {
            status: "ok",
            result: _context11.t0
          });
        case 8:
          _context11.prev = 8;
          _context11.t1 = _context11["catch"](1);
          console.error(_context11.t1);
          return _context11.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no hemos podido crear la información de facturación."
          });
        case 12:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[1, 8]]);
  }));
  return _setBillingInfo.apply(this, arguments);
}